define('shared/initializer/form/adapters/mixins/fields/PasswordLengthValidation',[
    'shared/lib/RSVP',
    '../../../constants'
], 
function(
    RSVP,
    constants
) {
    'use strict';

    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        var fieldPassword = me.items[constants.FIELD.PASSWORD];
        var localisedString = me.options.passwordLengthValidtionError !== 'et.form.password.length' ? me.options.passwordLengthValidtionError : '';

        if (!fieldPassword) return RSVP.resolve();

        fieldPassword.validate = function(value, options){
            if (fieldPassword.$el.val().length < 8) {
                return RSVP.reject(
                    fieldPassword.messages && fieldPassword.messages.invalid || 
                    (options && options.message) || 
                    localisedString ||
                    'Password must be 8 characters or more'
                );
            }
            else {
                return RSVP.resolve();
            }
        };   

        return RSVP.resolve();
    };

    return Ctor;
});
